import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useForceBotJoin = (eventId: string) => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<unknown, Error, void>({
    mutationFn: () => api.post(`calendar-events/${eventId}/force-bot-join`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId] });
    },
  });

  const forceBotJoin = async () => {
    await mutateAsync();
  };

  return {
    forceBotJoin,
    isLoading,
    error,
  };
};
